// removed by extract-text-webpack-plugin
module.exports = {"root":"pagination--root--2QfR-3-p","button":"pagination--button--3ZSniR0O","active":"pagination--active--3Q5wQcyh","arrow":"pagination--arrow--35-wd8SD"};


//////////////////
// WEBPACK FOOTER
// ./components/pagination/styles.css
// module id = ./components/pagination/styles.css
// module chunks = 0